import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { SettingsButton } from './SettingsButton/SettingsButton';
import { SettingsPopover } from './SettingsPopover/SettingsPopover';
import { SettingsProvider } from '../providers/SettingsProvider';
import { ViewProvider } from '../providers/ViewProvider';
const useOutsideClick = (popoverContainer, buttonContainer, isPopoverOpen, callback) => {
  useEffect(() => {
    const handleDocumentMouseDown = event => {
      const target = event.target;
      if (!target || !isPopoverOpen) {
        return;
      }
      const node = target;
      if (!popoverContainer.contains(node) && !buttonContainer.contains(node)) {
        callback();
      }
    };
    document.addEventListener('mousedown', handleDocumentMouseDown);
    return () => {
      document.removeEventListener('mousedown', handleDocumentMouseDown);
    };
  }, [popoverContainer, buttonContainer, isPopoverOpen, callback]);
};
export const ModuleUI = _ref => {
  let {
    buttonContainer,
    popoverContainer,
    onSpeedChange,
    config,
    isFullScreen
  } = _ref;
  const {
    onPopoverVisibilityChange
  } = config;
  const [isPopoverOpen, setPopoverOpen] = useState(false);
  const setVisibility = isOpen => {
    setPopoverOpen(isOpen);
    if (onPopoverVisibilityChange) {
      onPopoverVisibilityChange(isOpen);
    }
  };
  const handleButtonClick = () => {
    setVisibility(!isPopoverOpen);
  };
  useOutsideClick(popoverContainer, buttonContainer, isPopoverOpen, () => setVisibility(false));
  return /*#__PURE__*/React.createElement(SettingsProvider, {
    onSpeedChange: onSpeedChange,
    config: config
  }, /*#__PURE__*/React.createElement(ViewProvider, null, /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(SettingsButton, {
    onClick: handleButtonClick,
    big: isFullScreen
  }), buttonContainer), isPopoverOpen ? /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(SettingsPopover, null), popoverContainer) : null));
};
//# sourceMappingURL=ModuleUI.js.map